var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"title"},[_vm._v("开放对象")]),_c('p',{staticClass:"description"},[_vm._v("国内外高等院校、科研院所等单位的在职人员")]),_c('img',{staticClass:"building",attrs:{"src":_vm.buildingSrc}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }